export class AuthRequestModel {
  Platform: string;
  OperatingSystem: string;
  Version: string;
  Base: string;
  BidRound: number;
  Postion: string;
  Month: string;
  EmployeeNumber: string;
  Token: string;
  FromAppNumber: number;
  Password: string;
}
export class AuthResponseModel {
  IsAuthorized: boolean;
  AuthRequestId: number;
  Message: string;
  Type: string;
  ExpirationDate: Date;
  CBExpirationDate: Date;
  WBExpirationDate: Date;
  IsFree: boolean;
  IsYearlySubscribed: boolean;
  IsMonthlySubscribed: boolean;
  TopSubscriptionLine: string;
  SecondSubscriptionLine: string;
  ThirdSubscriptionLine: string;
  IsNeedtoEnableVacationDifference: boolean;
  FlightDataVersion: string;
}

export class UserDTO {
  // [Required(ErrorMessage = "Employee Number is required")]
  // [Display(Name = "Employee Number")]
  // [StringLength(8, ErrorMessage = "Employee Number cannot exceed 8 digits. ")]
  // [RegularExpression(@"^[E|X|e|x]?\d{1,7}$", ErrorMessage = "Invalid Employee Number ")]
  public empNum: string;

  // [Required(ErrorMessage = "Password is required")]
  // [Display(Name = "Password")]
  // [RegularExpression(@"^((?:(?!\s).){6,12})$", ErrorMessage = "Must be 6 to 12 characters without spaces")]
  // public Password: string;

  // [Required(ErrorMessage = "Confirm Password is required")]
  // [Display(Name = "Confirm Password")]
  // [RegularExpression(@"^((?:(?!\s).){6,12})$", ErrorMessage = "Must be 6 to 12 characters without spaces")]

  // public ConfirmPassword: string;

  // [Display(Name = "First Name")]
  // [Required(ErrorMessage = "First Name is required")]
  // [StringLength(50, ErrorMessage = "The First Name cannot exceed 50 characters. ")]
  public FirstName: string;

  // [Display(Name = "Last Name")]
  // [Required(ErrorMessage = "Last Name is required")]
  // [StringLength(50, ErrorMessage = "The Last Name cannot exceed 50 characters. ")]
  public LastName: string;

  public Pilot: boolean;
  // [Display(Name = "Flight Attendant")]
  public FlightAttendant: boolean;

  // [Required(ErrorMessage = "Select any position")]
  public PositionNumId?: number;

  // tslint:disable-next-line:max-line-length
  // [RegularExpression(@"^[a-zA-Z0-9_\+-]+(\.[a-zA-Z0-9_\+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,4})$", ErrorMessage = "Inavlid Email ")]
  // [StringLength(100, ErrorMessage = "The Email cannot exceed 100 characters. ")]
  // [Required(ErrorMessage = "Email is Required")]
  public Email: string;

  // tslint:disable-next-line:max-line-length
  // [RegularExpression(@"^[a-zA-Z0-9_\+-]+(\.[a-zA-Z0-9_\+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,4})$", ErrorMessage = "Inavlid Email ")]
  // [StringLength(100, ErrorMessage = "The Email cannot exceed 100 characters. ")]
  // [Display(Name = "Confirm Email")]
  // [Required(ErrorMessage = "Repeat Email is Required")]
  public ConfirmEmail: string;

  public TextPreference: string;

  public DropTextPref: number;

  // [Display(Name = "Cell Number")]
  // [Required(ErrorMessage = "Cell Number is Required")]
  // tslint:disable-next-line:max-line-length
  // [RegularExpression(@"^((\(\d{3}\) )|(\d{3}-))\d{3}-\d{4}$", ErrorMessage = "Invalid Cell Number eg: xxx-xxx-xxxx or (xxx) xxx-xxxx format.")]
  public Cell: string;

  public RoleName: string;

  public CellCarrier: string;

  // [Required(ErrorMessage = "Please Select any carrier")]
  public DropCellCarrier: number;

  // [Display(Name = "Cell Carrier")]
  // [Required(ErrorMessage = "Cell Carrier is Required")]
  public CarrierNum: number;

  public Created: Date;

  public Validated?: Date;

  public Updated?: Date;

  public IsFree: boolean;

  public RoleNumId: number;
  // [Display(Name = "Accept Email from WBid")]

  public isAcceptEmail: boolean;

  public IsSubscribed?: boolean;

  public VersionNumId?: number;

  // [Display(Name = "Text Preference")]
  // [Required(ErrorMessage = "Text Preference is Required")]
  public TextPrefNumId: number;

  public FreeUntilDate: Date;

  public isCreation: boolean;
  public FromAppNum: number;
}
export class Users {
  // [Required(ErrorMessage = "Employee Number is required")]
  // [Display(Name = "Employee Number")]
  // [StringLength(8, ErrorMessage = "Employee Number cannot exceed 8 digits. ")]
  // [RegularExpression(@"^[E|X|e|x]?\d{1,7}$", ErrorMessage = "Invalid Employee Number ")]
  public EmpNum: number;

  // [Required(ErrorMessage = "Password is required")]
  // [Display(Name = "Password")]
  // [RegularExpression(@"^((?:(?!\s).){6,12})$", ErrorMessage = "Must be 6 to 12 characters without spaces")]
  public Password: string;

  // [Required(ErrorMessage = "Confirm Password is required")]
  // [Display(Name = "Confirm Password")]
  // [RegularExpression(@"^((?:(?!\s).){6,12})$", ErrorMessage = "Must be 6 to 12 characters without spaces")]

  // [Display(Name = "First Name")]
  // [Required(ErrorMessage = "First Name is required")]
  // [StringLength(50, ErrorMessage = "The First Name cannot exceed 50 characters. ")]
  public FirstName: string;

  // [Display(Name = "Last Name")]
  // [Required(ErrorMessage = "Last Name is required")]
  // [StringLength(50, ErrorMessage = "The Last Name cannot exceed 50 characters. ")]
  public LastName: string;

  public Pilot: boolean;
  // [Display(Name = "Flight Attendant")]
  public FlightAttendant: boolean;

  // [Required(ErrorMessage = "Select any position")]
  public PositionNum?: number;

  // tslint:disable-next-line:max-line-length
  // [RegularExpression(@"^[a-zA-Z0-9_\+-]+(\.[a-zA-Z0-9_\+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,4})$", ErrorMessage = "Inavlid Email ")]
  // [StringLength(100, ErrorMessage = "The Email cannot exceed 100 characters. ")]
  // [Required(ErrorMessage = "Email is Required")]
  public Email: string;

  // [Display(Name = "Cell Number")]
  // [Required(ErrorMessage = "Cell Number is Required")]
  // tslint:disable-next-line:max-line-length
  // [RegularExpression(@"^((\(\d{3}\) )|(\d{3}-))\d{3}-\d{4}$", ErrorMessage = "Invalid Cell Number eg: xxx-xxx-xxxx or (xxx) xxx-xxxx format.")]
  public Cell: string;

  // [Display(Name = "Cell Carrier")]
  // [Required(ErrorMessage = "Cell Carrier is Required")]
  public CarrierNum: number;

  public Created: Date;

  public Validated?: Date;

  public Updated?: Date;

  public IsFree: boolean;

  public RoleNum: number;
  // [Display(Name = "Accept Email from WBid")]

  public AcceptEmail: boolean;

  public IsSubscribed?: boolean;

  public VersionNum?: number;

  // [Display(Name = "Text Preference")]
  // [Required(ErrorMessage = "Text Preference is Required")]
  public TextPrefNum: number;

  public FreeUntil: Date;
}

export class CustomResponse {
  public Status: string;
  public Message: string;
}

export class UserContactUs {
  public FirstName: string;
  public LastName: string;
  public Email: string;
  public Description: string;
  public AppVersion: string;
  public EmployeeNumber: string;
  public PhoneNumber: string;
  public Base: string;
  public Position: string;
  public ResMessage: string;
  public Platform: string;
  public subject: string;
  public  AttachmentData:String;
  public  AttachmentName:String ;
  public  TestEmail:String;
}
export class AuthRequestModelFA {
  Platform: string;
  OperatingSystem: string;
  Version: string;
  Base: string;
  BidRound: number;
  Postion: string;
  Month: string;
  EmployeeNumber: string;
  Token: string;
  FromAppNumber: number;
}
